import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const Meta = ({ title, description, keywords }) => {
	return (
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description} />
			<meta name="keywords" content={keywords} />
		</Helmet>
	)
}

Meta.defaultProps = {
	title: 'Welcome to LinkLink & KomKom Shop',
	keywords: 'electronics, buy electronics, cheap electronics',
	description: 'We sell what we use'
}

Meta.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	keywords: PropTypes.string
}

export default Meta
